import script from "./TeacherManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherManagement.vue?vue&type=script&setup=true&lang=js"

import "./TeacherManagement.vue?vue&type=style&index=0&id=028e6542&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-028e6542"]])

export default __exports__